

















































































import {
  computed,
  defineComponent,
  getCurrentInstance,
  onBeforeUnmount,
  onMounted,
  ref,
} from '@vue/composition-api'

import HExcelManualModal from '@/components/organisms/h/HExcelManualModal.vue'
import { getManualsBaseUrl } from '@/utils/manual/config'
import {
  loadExcelManual,
  loadScreenTour,
  ManualLoadError,
} from '@/utils/manual/loader'
import { startScreenTour } from '@/utils/manual/tour'
import {
  TOUR_TONES,
  TourToneId,
  applyTourTone,
  getTourTone,
  isTourToneSwitchEnabled,
} from '@/utils/manual/tour-colors'

export default defineComponent({
  name: 'HScreenManualMenu',
  components: {
    HExcelManualModal,
  },
  setup() {
    const instance = getCurrentInstance()
    const loading = ref(false)
    const errorMessage = ref('')
    const showCalc = ref(false)
    const menuOpen = ref(false)
    const toneOpen = ref(false)
    const selectedTone = ref<TourToneId>(getTourTone())
    const helpRoot = ref<HTMLElement | null>(null)
    const toneEnabled = isTourToneSwitchEnabled()
    const tones = TOUR_TONES

    const closeMenu = () => {
      menuOpen.value = false
      toneOpen.value = false
    }

    const toggleMenu = () => {
      toneOpen.value = false
      menuOpen.value = !menuOpen.value
    }

    const toggleTone = () => {
      menuOpen.value = false
      toneOpen.value = !toneOpen.value
    }

    const chooseTone = (toneId: TourToneId) => {
      selectedTone.value = toneId
      applyTourTone(toneId)
      toneOpen.value = false
    }

    const onDocumentClick = (event: MouseEvent) => {
      const root = helpRoot.value
      if (!root || !menuOpen.value) {
        return
      }
      if (!root.contains(event.target as Node)) {
        closeMenu()
      }
    }

    onMounted(() => {
      document.addEventListener('click', onDocumentClick)
    })
    onBeforeUnmount(() => {
      document.removeEventListener('click', onDocumentClick)
    })

    const routePath = computed(() => {
      if (!instance) {
        return '/h'
      }
      return instance.proxy.$route.path
    })

    const calcOverviewUrl = computed(() => {
      const path = routePath.value
      let hash = ''
      if (path.startsWith('/h/jyuyou-yosoku')) {
        hash = '#demand'
      } else if (
        path.startsWith('/h/yosan-haibun') ||
        path.startsWith('/h/order-budget')
      ) {
        hash = '#budget'
      } else if (path.startsWith('/h/new-store-bulk-order')) {
        hash = '#new-store'
      }
      return `${getManualsBaseUrl()}/h/calc-overview.html${hash}`
    })

    const onStartTour = async () => {
      errorMessage.value = ''
      loading.value = true
      try {
        const manual = await loadScreenTour(routePath.value)
        startScreenTour(manual)
      } catch (e) {
        errorMessage.value =
          e instanceof ManualLoadError
            ? e.message
            : '画面の説明を開始できませんでした'
      } finally {
        loading.value = false
      }
    }

    const onOpenExcel = async () => {
      errorMessage.value = ''
      loading.value = true
      try {
        const manual = await loadExcelManual(routePath.value)
        // @ts-ignore
        instance.proxy.$refs.excelModal.show(manual, routePath.value)
      } catch (e) {
        errorMessage.value =
          e instanceof ManualLoadError
            ? e.message
            : 'Excelの説明を表示できませんでした'
      } finally {
        loading.value = false
      }
    }

    const onOpenCalc = () => {
      errorMessage.value = ''
      showCalc.value = true
    }

    const chooseTour = () => {
      closeMenu()
      onStartTour()
    }

    const chooseExcel = () => {
      closeMenu()
      onOpenExcel()
    }

    const chooseCalc = () => {
      closeMenu()
      onOpenCalc()
    }

    return {
      loading,
      errorMessage,
      showCalc,
      menuOpen,
      toneOpen,
      toneEnabled,
      tones,
      selectedTone,
      helpRoot,
      calcOverviewUrl,
      toggleMenu,
      toggleTone,
      chooseTone,
      chooseTour,
      chooseExcel,
      chooseCalc,
    }
  },
})
